import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { useMemo } 						   from 'react';
import LoadingTable 						   from '../Table/LoadingTable';
import { ReactComponent as ExcelIcon } 		   from '../../assets/DemandTableModal/excel.svg'	
import dayjs 								   from 'dayjs';
import { formartMillarNumber } 				   from '../../utils/stylesUtils';
import '../../styles/LoadingTable.css'

function DemandsTableModal({ 
	
	isOpen, 
	onClose, 

	loading, 

	hasPermission,
	
	handleApprovalChange,
	handleCommentChange,
	handleSubmitApprovals,

	allApprovedBtnStatus,
	toggleAllApprovals,

	modalTitle, 
    demandPostColumns,
    demandPostLines,
	handleClick,
	selectedDemandPostId,

	textFilter,
	setTextFilter,
	approvalFilter,
	setApprovalFilter

}) {

	const totals = useMemo(() => {

		if (!Array.isArray(demandPostLines) || !Array.isArray(demandPostColumns)) {
			return { columnsTotals: {}, approvedCount: 0 }
		}

		const columnsTotals = {}
		demandPostColumns.forEach((column) => { columnsTotals[column.id] = 0 })

		let approvedCount = 0

		demandPostLines.forEach((line) => {

			line.demands.forEach((demand) => {
				if (columnsTotals[demand.demandPostColumnId] !== undefined) {
					columnsTotals[demand.demandPostColumnId] += Number(demand.wagons) || 0
				}
			})

			if (line.isApproved) approvedCount += 1

		})

		return { columnsTotals, approvedCount }

	}, [demandPostLines, demandPostColumns])
	
	return (
		
		<Dialog open={isOpen} onClose={onClose} className={isOpen ? 'relative z-[100]' : 'hidden'}>
		
		<DialogBackdrop 
			onClick={onClose} 
			transition 
			className="fixed inset-0 bg-bg-backdrop transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in" 
		/>
		
		<div className="fixed inset-0 z-10 w-screen overflow-y-auto">
			
			<div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
			
			<DialogPanel 
				transition 
				className=" min-w-[80%] relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
			>   
				<div className="app-container">
				
					<header className="bg-azul-profundo-m flex justify-between items-center pl-4 pr-1 py-3">
						
						{loading ? (
							<div className='three bg-azul-profundo-e w-[100px] rounded-[16px] h-[25px]'> </div>
						) : (
							<h2 className="text-white text-[1rem] leading-7 font-semibold">
								{modalTitle} 
							</h2>
						)}
						
						<button className="text-[1.2rem] text-white hover:text-gray-200 pr-2" onClick={onClose}>×</button>
					
					</header>

					<div className="h-[700px] overflow-y-auto p-[15px] ">
						
						{loading ? (

							<LoadingTable/>
							
						) : (
							
							<div className='flex flex-col gap-2'>
								
								<div className='flex gap-2'>

									{hasPermission&& (
										<button 
											className={`!p-[3px] btn w-[15%] ${allApprovedBtnStatus ? 'btn-vermelho' : 'btn-letra-verde'}`}
											onClick={toggleAllApprovals}
										>
											{allApprovedBtnStatus ? 'Reprovar todos' : 'Aprovar todos'}
											
										</button>
									)}
									

									<button
										className='btn btn-letra-verde !p-[3px]' 
										onClick={() => handleClick(selectedDemandPostId.id)}
									>
										<ExcelIcon/>
									</button>

								</div>

								<div className='flex justify-between items-center flex-wrap gap-2'>

									<div className='flex items-center gap-3 flex-wrap'>

										<input
											type="text"
											value={textFilter}
											onChange={(e) => setTextFilter(e.target.value)}
											placeholder="Filtrar (separe varios termos com ;)"
											className="border rounded-[8px] px-3 py-1 text-sm w-[320px] max-w-full"
										/>

										<div className="flex items-center rounded-[8px] overflow-hidden border">

											<button
												type="button"
												onClick={() => setApprovalFilter('todos')}
												className={`px-3 py-1 text-sm ${approvalFilter === 'todos' ? 'bg-gray-300 text-gray-800' : 'bg-white text-gray-500'}`}
											>
												Todos
											</button>

											<button
												type="button"
												onClick={() => setApprovalFilter('aprovado')}
												className={`px-3 py-1 text-sm ${approvalFilter === 'aprovado' ? 'bg-[#6bf76b70] text-[#06aa06]' : 'bg-white text-gray-500'}`}
											>
												Aprovado
											</button>

											<button
												type="button"
												onClick={() => setApprovalFilter('reprovado')}
												className={`px-3 py-1 text-sm ${approvalFilter === 'reprovado' ? 'bg-[#f76bc370] text-[#AA0657]' : 'bg-white text-gray-500'}`}
											>
												Reprovado
											</button>

										</div>

									</div>

									<span className="text-sm text-gray-500 italic">
										{demandPostLines.length} linhas.
									</span>

								</div>
								
								
								<table className=" rounded-[8px] [border-spacing:0] border-separate min-w-full border">
									
									<thead className=" bg-neutro ">
										
										<tr>

											<th className='rounded-tl-[8px] font-small text-[small] p-[0.5rem] border-b-[1px_solid_#e3e2e2] text-center'>#</th>
											<th className='font-small text-[small] p-[0.5rem] border-b-[1px_solid_#e3e2e2] text-center'>Terminal</th>
											<th className='font-small text-[small] p-[0.5rem] border-b-[1px_solid_#e3e2e2] text-center'>Produto</th>
											
											{demandPostColumns?.map((demandPostColumn, index) => (
												
												<th 
													className={
														`font-small 
														text-[small] 
														p-[0.5rem] 
														border-b-[1px_solid_#e3e2e2] 
														text-center ${index === demandPostColumns.length - 1 ? 'rounded-tr-[8px]' : ''}`
													} 
													key={index}
												>	
													<div 
														className='flex flex-col'
													>
														<span className='text-[small]'>
															{demandPostColumn.name}
														</span>
														
														<span className='text-[x-small] text-gray-600'>
														{
															dayjs(
																demandPostColumn.date
															).format(
																demandPostColumn.ownerDemandPost.ownerDemandHorizon.ownerHorizonOfPlan.columnsFo
															)
														}
														</span>	

														
													</div>
												</th>
											))}

											<th className='font-small text-[small] p-[0.5rem] border-b-[1px_solid_#e3e2e2] text-center'>
												Aprovado
											</th>

											<th className='font-small text-[small] p-[0.5rem] border-b-[1px_solid_#e3e2e2] text-center'>Comentário</th>

										</tr>	

									</thead>

									<tbody>

										{demandPostLines.map((demandPostLine, index) => (
											
											<tr key={index} className="hover:bg-neutro transition-colors">

												
												<td title={`ID: ${demandPostLine.id}`} className="text-[smaller] border text-sm text-left px-2 py-1 cursor-default">{String(index + 1).padStart(2, '0')}</td>
												<td className="text-[smaller] border text-sm text-left px-2">{demandPostLine.ownerTerminal.name}</td>
												<td className="text-[smaller] border text-sm text-left px-2">{demandPostLine.ownerProduct.name}</td>

												{demandPostColumns.map((demandPostColumn, colIndex) => (
													
													
													<td 
														key={`${demandPostLine.id}-${colIndex}`} 
														className="text-[smaller] border text-sm text-right px-2"
													>
														{
															demandPostLine.demands.find(demand => demand.demandPostColumnId === demandPostColumn.id) ? 
															formartMillarNumber(demandPostLine.demands.find(demand => demand.demandPostColumnId === demandPostColumn.id).wagons) 
															: '-'}
													
													</td>
												))}

												<td className="text-[smaller] border text-sm text-left px-2">

													<input 
														disabled={!hasPermission}
														id={`canEdit-${demandPostLine.id}`}
														type="checkbox" 
														checked={demandPostLine.isApproved || false}
														className="w-4 h-4 !m-auto !block ![appearance:auto] text-blue-600 bg-gray-100 border-gray-300 rounded-sm"
														onChange={() => handleApprovalChange(demandPostLine.id)}
													/>

												</td>

												<td className="text-[smaller] border text-sm text-left px-2">
													
													{hasPermission ? (
														<input
															type="text"
															value={demandPostLine.description || ''}
															className="w-full"
															placeholder="--"
															onChange={(e) => handleCommentChange(demandPostLine.id, e.target.value)}
														/>
													) : (
														<span
															className="w-full"
														>{demandPostLine.description || '--'}</span>
													)}
													

												</td>

											</tr>
										))}

									</tbody>

									<tfoot>

										<tr className="bg-neutro font-semibold">

											<td colSpan={3} className="text-[smaller] border text-sm text-left px-2 py-1">Total</td>

											{demandPostColumns.map((demandPostColumn) => (
												<td key={demandPostColumn.id} className="text-[smaller] border text-sm text-right px-2">
													{formartMillarNumber(totals.columnsTotals[demandPostColumn.id] || 0)}
												</td>
											))}

											<td className="text-[smaller] border text-sm text-center px-2">
												{totals.approvedCount}/{demandPostLines.length} aprovados
											</td>

											<td className="border"></td>

										</tr>

									</tfoot>

								</table>
								
							</div>
						)}

					</div>

					<footer className='flex flex-col gap-2 p-2 rounded-[5px] bg-neutro'>
						{hasPermission && (
							<button onClick={handleSubmitApprovals} className='btn btn-azul-prof w-[100%]'>Salvar Avaliação</button>
						)}	
					</footer>

				</div>

			</DialogPanel>

			</div>
		
		</div>
		</Dialog>
	);
}

export default DemandsTableModal;